import React from 'react'
import './Statistics.css'
import firebase from 'firebase/app'
import 'firebase/database'
import {initializeFirebase} from '../firebaseDatabase'
import { Doughnut } from 'react-chartjs-2';
import Pagination from "react-js-pagination";
import store from '../redux';
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
global.jQuery = $;

class Statistics extends React.Component{
    constructor(props){
        super();
        this.state ={
            data : [],
            dataByStart: [],
            dataByEnd: [],
            total: 0,
            berhasil: 0,
            gagal: 0,
            tersisa: 0,
            activePage: 1,
            selectValue: 'default',
            filterBy: 'total'
        }

        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        if (!firebase.apps.length) {
            initializeFirebase();
        }
        firebase.database().ref('/'+store.getState().state.googleId+store.getState().state.email.replace(/[^a-zA-Z0-9]/g, '')+'/calendar').once('value').then(snap => {
            this.setState({
                data : snap.val() 
            })
            if(this.state.data !== null) {
                this.getTotal(this.state.data)
                this.getBerhasil(this.state.data)
                this.getGagal(this.state.data)
                this.getTersisa(this.state.data)
                
                this.sortByStart(this.state.data)
                this.sortByEnd(this.state.data)
            }
        });        
    }

    getTotal(data) {
        this.setState({total : Object.values(data).length})
    }

    getBerhasil(data) {
        this.setState({berhasil: Object.values(data).filter((e) => e.color === '#5cb85c').length})
    }
    
    getGagal(data) {
        this.setState({gagal: Object.values(data).filter((e) => e.color === '#f0ad4e').length})
    }

    getTersisa(data) {
        this.setState({tersisa: Object.values(data).filter((e) => e.color !== '#f0ad4e').filter((e) => e.color !== '#5cb85c').length})
    }

    handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
    }

    reformatDate(dateStr) {
        let dArr = dateStr.split("-"); 
        return dArr[2]+ "-" +dArr[1]+ "-" +dArr[0];
    }

    sortByStart(data) {
        let sortedData = Object.values(this.state.data).sort((a,b) => parseFloat(a.start.replaceAll('-','')) - parseFloat(b.start.replaceAll('-','')))
        this.setState({
            dataByStart : sortedData
        })
    }

    sortByEnd(data) {
        let sortedData = Object.values(this.state.data).sort((a,b) => parseFloat(a.end.replaceAll('-','')) - parseFloat(b.end.replaceAll('-','')))
        this.setState({
            dataByEnd : sortedData
        })
    }

    handleSelectChange(event) {
        this.setState({selectValue: event.target.value});
    }


    render() {
        return (
            <div className="statistics" style={this.props.expanded ? {paddingLeft:20+"%"} : {paddingLeft:8+"%"} }>
                <h1>Statistics</h1>
                <h5 className="text-left mt-3 mb-3">Resolusi : </h5>
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-2 border rounded shadow bg-info text-light m-auto">
                        <div className="row" style={{cursor:"pointer"}} onClick={() => this.setState({filterBy: 'total', activePage: 1})}>
                            <div className="col-lg-5 m-auto ">
                                <i className="fa fa-star" aria-hidden="true"></i>
                            </div>
                            <div className="col-lg-7 m-auto p-3 rtext">
                                Total
                                <h3>{this.state.total}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 border rounded shadow bg-success text-light m-auto">
                        <div className="row" style={{cursor:"pointer"}} onClick={() => this.setState({filterBy: 'berhasil', activePage: 1})}>
                            <div className="col-lg-5 m-auto ">
                                <i className="fa fa-check" aria-hidden="true"></i>
                            </div>
                            <div className="col-lg-7 m-auto p-3 rtext">
                                Berhasil
                                <h3>{this.state.berhasil}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 border rounded shadow bg-warning text-light m-auto">
                        <div className="row" style={{cursor:"pointer"}} onClick={() => this.setState({filterBy: 'gagal', activePage: 1})}>
                            <div className="col-lg-5 m-auto ">
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </div>
                            <div className="col-lg-7 m-auto p-3 rtext">
                                Gagal
                                <h3>{this.state.gagal}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 border rounded shadow bg-primary text-light m-auto">
                        <div className="row" style={{cursor:"pointer"}} onClick={() => this.setState({filterBy: 'belum', activePage: 1})}>
                            <div className="col-lg-5 m-auto ">
                                <i className="fa fa-hourglass-half" aria-hidden="true"></i>
                            </div>
                            <div className="col-lg-7 m-auto p-3 rtext">
                                Belum
                                <h3>{this.state.tersisa}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-7 tabelResolusi mx-auto">
                        <h5 className="text-left mb-3">Tabel Resolusi</h5>
                        <div className="float-left p-0 onMobile">
                            <label className="mr-1"><small>Berdasarkan :</small></label>
                            <select className="border p-1 rounded" value={this.state.selectValue} onChange={this.handleSelectChange}>
                                <option value="default">Waktu Input</option>
                                <option value="sortByStart">Tanggal Mulai</option>
                                <option value="sortByEnd">Tanggal Berakhir</option>
                            </select>
                        </div>
                        <table className="table table-hover table-responsive">
                            <thead >
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Resolusi</th>
                                    <th scope="col">Mulai</th>
                                    <th scope="col">Berakhir</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data !== null ? 
                                Object.values(this.state.selectValue === 'default' ? this.state.data : this.state.selectValue === 'sortByStart' ? this.state.dataByStart : this.state.dataByEnd)
                                    .filter((e) => this.state.filterBy === 'total' ? e.title !== null : this.state.filterBy === 'berhasil' ? e.color === "#5cb85c" : this.state.filterBy === 'gagal' ? e.color === "#f0ad4e" : e.color !== "#5cb85c" && e.color !== "#f0ad4e")
                                    .slice((this.state.activePage-1)*5,(this.state.activePage*5))
                                    .map(
                                        (data, i) => 
                                        <tr key={i}>
                                            <td>{i+1+((this.state.activePage-1)*5)}</td>
                                            <td><small>{data.title}</small></td>
                                            <td><small>{this.reformatDate(data.start)}</small></td>
                                            <td><small>{this.reformatDate(data.end)}</small></td>
                                            <td>{data.color === undefined || data.color === "" ? <small className="rounded-pill bg-primary text-white py-1 px-2">Belum Tercapai</small> : (data.color === '#5cb85c' ? <small className="rounded-pill bg-success text-white py-1 px-2">Berhasil</small> : <small className="rounded-pill bg-warning text-white py-1 px-2">Gagal</small>)} </td>
                                        </tr>
                                )
                                : this.state.filterBy === 'total' ? <tr><td colspan="5">Data tidak ditemukan</td></tr> : <tr></tr>}
                                {this.state.filterBy === 'berhasil' && this.state.berhasil === 0 ? <tr><td colspan="5">Data resolusi berhasil tidak ditemukan</td></tr> : <tr></tr>}
                                {this.state.filterBy === 'gagal' && this.state.gagal === 0 ? <tr><td colspan="5">Data resolusi gagal tidak ditemukan</td></tr> : <tr></tr>}
                                {this.state.filterBy === 'belum' && this.state.tersisa === 0 ? <tr><td colspan="5">Data resolusi belum tercapai tidak ditemukan</td></tr> : <tr></tr>}
                            </tbody>
                        </table>
                        <div className="float-left p-0 onWeb">
                            <label className="mr-1"><small>Berdasarkan :</small></label>
                            <select className="border p-1 rounded" value={this.state.selectValue} onChange={this.handleSelectChange}>
                                <option value="default">Waktu Input</option>
                                <option value="sortByStart">Tanggal Mulai</option>
                                <option value="sortByEnd">Tanggal Berakhir</option>
                            </select>
                        </div>
                        <div className="float-right p-0">
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                activePage={this.state.activePage}
                                itemsCountPerPage={5}
                                totalItemsCount={this.state.filterBy === 'total' ? this.state.total : this.state.filterBy === 'berhasil' ? this.state.berhasil : this.state.filterBy === 'gagal' ? this.state.gagal : this.state.tersisa}
                                pageRangeDisplayed={3}
                                onChange={this.handlePageChange.bind(this)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-5 mx-auto grafikDonat">
                        <h5 className="mb-3">Grafik Resolusi</h5>
                        <Doughnut data={{
                        labels: [
                            'Berhasil ',
                            'Gagal ',
                            'Belum Tercapai '
                        ],
                        datasets: [{
                            data: [this.state.berhasil, this.state.gagal, this.state.tersisa],
                            backgroundColor: [
                                'rgba(92, 184, 92,1)',
                                '#FFCE56',
                                '#36A2EB',
                            ],
                            hoverBackgroundColor: [
                                'rgba(92, 184, 92,1)',
                                '#FFCE56',
                                '#36A2EB',
                            ]
                        }]
                        }} />
                    </div>
                </div>
            </div>
        )
    }
}

export default Statistics;
